import React from 'react';

const Quote = ({ quote, quoteSource, light }) => {

  if (light) {
    return (
      <div className="mb-[48px] md:mb-[48px] max-w-[792px] mx-auto quote">
        <div className="font-heading text-h1 text-aqua -mb-4">“</div>
        <div className="quote">{quote}</div>
        <p className='text-right pt-2'>{quoteSource}</p>
      </div>
    );
  }
  return (
    <div className="mb-[48px] md:mb-[73px] max-w-[792px] mx-auto">
      <div className="font-heading text-h1 text-aqua">“</div>
      <h3 className="text-h3">{quote}</h3>
    </div>
  );

};

export default Quote;
